<template>
  <section>
		<p class="reset-moblie-tip">
			<span class="icon iconfont icon-error-circle"></span>
			为了保护您的账号安全，需要验证您的身份，验证通过后即可更改手机号
		</p>
		<div
			class="reset-moblie-ctn"
			@click="chooseType('byMobile')"
		>
			<img class="lf-img" :src="Images.IMAGE_MOBLIE" alt="" />
			<div class="reset-moblie-txt">
				<span class="txt-bold">手机号码验证更换</span>
				<br />
				<span class="txt"
					>通过{{ currentAccountInfo.mobileFuzzy }}手机号接收短信验证码</span
				>
			</div>
		</div>
		<div
			class="reset-moblie-ctn"
			@click="chooseType('byMan')"
		>
			<img class="lf-img" :src="Images.IMAGE_APPEAL" alt="" />
			<div class="reset-moblie-txt">
				<span class="txt-bold">人工申诉更换</span>
				<br />
				<span class="txt"
					>无法用原手机号验证，需要提交申请表、公司或个人盖章、签字等</span
				>
			</div>
		</div>
  </section>
</template>
<script lang="ts" setup>
import { Images } from "@/assets/Images"

import * as easy from "@/components/easy";

import { currentAccountInfo } from "../../State";

const props = defineProps<{ 
	popupCtx?: easy.PopupCtx<'byMobile' | 'byMan'>
 }>()

const popup = easy.usePopup(props);

function chooseType(type: 'byMobile' | 'byMan') {
	popup.done(type);
}

</script>
<style lang="scss" scoped>
:deep(.el-dialog__title) {
  font-size: 14px;
  color: #303133;
  font-weight: 600;
}
:deep(.el-dialog__header) {
  padding: 15px 16px;
  //   border-bottom: 1px solid #e4e9f0;
}
:deep(.el-dialog__body) {
  padding: 16px;
  border: 1px solid #e4e9f0;
  border-left: none;
  border-right: none;
}
:deep(.el-dialog__footer) {
  padding: 12px 20px;
}

.reset-moblie-tip {
  width: 528px;
  height: 40px;
  padding: 6px 16px;
  background: #fef8eb;
  border-radius: 2px;
  border: 1px solid #fcbd40;
  .icon-error-circle {
    color: #fcbd40;
  }
}
.reset-moblie-ctn {
  cursor: pointer;
  display: flex;
  height: 72px;
  background: #f7f8fa;
  border-radius: 2px;
  padding: 6px 12px;
  margin: 16px 0;
  &:last-child {
    margin-bottom: 94px;
  }
  // &.is-select {
  //   background: #e6f2ff;
  //   border: 1px solid #add4ff;
  // }
  .lf-img {
    width: 60px;
    height: auto;
    vertical-align: middle;
  }
  .reset-moblie-txt {
    display: inline-block;
    margin-left: 14px;
    font-size: 14px;
    color: #303133;
    margin-top: 8px;
    .txt-bold {
      font-size: 14px;
      color: #303133;
      font-weight: bold;
    }
    .txt {
      font-size: 12px;
      font-weight: 400;
      color: #606266;
    }
  }
}
</style>
